export default "__VITE_ASSET__Brjcx6r0__"